export default defineNuxtPlugin((nuxtApp) => {
  const breakpoints = {
    tablet: 744,
    tablet2: 1024,
    pc: 1367,
  }

  const isSp = screenWidth => {
    return screenWidth < breakpoints.tablet
  }

  const isTablet = screenWidth => {
    return (
      screenWidth >= breakpoints.tablet && screenWidth < breakpoints.tablet2
    )
  }

  const isTablet2 = screenWidth => {
    return screenWidth >= breakpoints.tablet2 && screenWidth < breakpoints.pc
  }

  const isPc = screenWidth => {
    return screenWidth >= breakpoints.pc
  }

  return {
    provide: {
      isSp: () => isSp(),
      isTablet: () => isTablet(),
      isTablet2: () => isTablet2(),
      isPc: () => isPc(),
    }
  }
})
